import React, { useEffect } from "react";
import "./ErrorPage.css";

const ErrorPage = () => {
   useEffect(() => {
      //Third answer down here
      //https://stackoverflow.com/questions/179355/clearing-all-cookies-with-javascript
      //Since Error comes with only one navigation option, to login, makes sense that we remove any
      //invalid cookies that have likely led to the user being redirected here.
      let cookies = document.cookie.split("; ");
      for (let c = 0; c < cookies.length; c++) {
         let d = window.location.hostname.split(".");
         while (d.length > 0) {
            let cookieBase =
               encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
               "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
               d.join(".") +
               " ;path=";
            let p = location.pathname.split("/");
            document.cookie = cookieBase + "/";
            while (p.length > 0) {
               document.cookie = cookieBase + p.join("/");
               p.pop();
            }
            d.shift();
         }
      }
   }, []);

   let newLocation = `${window.location.origin}/sourceone/login`;

   return (
      <div className="error-page">
         <form action="">
            <p style={{ marginBottom: "20px" }}>
               There was an error loading the SourceOne website. If this problem
               continues please contact your administrator.
            </p>
            <a href={newLocation}>SourceOne Login Page</a>
         </form>
      </div>
   );
};

export default ErrorPage;
